interface Props {
  /** Alto del ícono en px. El ancho se ajusta solo (viewBox cuadrado). */
  size?: number;
  /** Muestra "BlackRed Studio" junto al ícono. */
  withWordmark?: boolean;
  className?: string;
}

/** Isotipo original de Blackrednow (ojo grafito/rojo) redibujado como vector propio — mismo
 *  archivo fuente que `public/favicon.svg`, expuesto también como componente para poder
 *  colocarlo en encabezados sin depender de un <img> aparte. Ver ese archivo para el
 *  razonamiento de diseño. */
export function BrandMark({ size = 40, withWordmark = false, className }: Props) {
  return (
    <span
      className={["brand-mark", className].filter(Boolean).join(" ")}
      style={{ display: "inline-flex", alignItems: "center", gap: 10 }}
    >
      <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="BlackRed Studio">
        <defs>
          <linearGradient id="brn-red-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#ff6a56" />
            <stop offset="1" stopColor="#b2131b" />
          </linearGradient>
          <linearGradient id="brn-dark-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#33363f" />
            <stop offset="1" stopColor="#0d0e11" />
          </linearGradient>
        </defs>
        <path d="M32 8 C 47 8 59.5 18 63 32 C 59.5 46 47 56 32 56 Z" fill="url(#brn-red-g)" />
        <path d="M32 8 C 17 8 4.5 18 1 32 C 4.5 46 17 56 32 56 Z" fill="url(#brn-dark-g)" />
        <circle cx="32" cy="32" r="12" fill="#0a0b0d" />
        <circle cx="32" cy="32" r="12" fill="none" stroke="#000" strokeOpacity={0.35} strokeWidth={1} />
        <circle cx="36.5" cy="26.5" r="3.1" fill="#fff" fillOpacity={0.92} />
      </svg>
      {withWordmark && (
        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.05 }}>
          <strong style={{ fontFamily: "Manrope, sans-serif", fontWeight: 800, fontSize: size * 0.34, letterSpacing: "-0.02em", color: "#f1f1f3" }}>
            BlackRed<span style={{ color: "var(--red)" }}>Studio</span>
          </strong>
        </span>
      )}
    </span>
  );
}
